import { BaseParams, NodeData } from './base';
import { type ContextItemData, type EntityItemData } from './types';

/**
 * Type used to create an entity context item.
 */
export interface CreateEntityContextParams extends BaseParams {
  type: string;
  name: string;
  scope?: {
    env?: string;
    site?: string;
    namespace?: string;
  };
  properties?: Record<string, any>;
}

export class EntityNodeData extends NodeData {
  public entityType: string;
  public name: string;
  public scope?: {
    env?: string;
    site?: string;
    namespace?: string;
  };
  public properties?: Record<string, any>;

  constructor(params: CreateEntityContextParams) {
    super({
      id: `${params.type}-${params.name}-${[params.scope?.env, params.scope?.site, params.scope?.namespace].filter(Boolean).join('-')}`,
      type: 'entity',
      title: params.title,
      hidden: params.hidden,
      img: params.img,
      icon: params.icon,
      text: params.name,
    });
    this.entityType = params.type;
    this.name = params.name;
    this.scope = params.scope;
    this.properties = params.properties;
    this.text = params.name;
  }

  formatForLLM(codeElementIds?: string[]): ContextItemData {
    return {
      type: 'entity',
      codeElementIds,
      bypassLimits: this.bypassLimits,
      data: {
        name: this.name,
        text: this.text,
        type: this.entityType,
        scope: this.scope,
        properties: this.properties,
      } satisfies EntityItemData,
    };
  }
}
